import {
  CREATE_ORDER_REQUEST,
  GET_EXISTING_ORDER_REQUEST,
  SET_EXISTING_ORDERS,
  SET_ORDER,
  SET_ORDER_DELIVERY_DETAILS
} from './order.action';

const initialState = {
  order: null,
  existingOrders: [],
  orderDeliveryDetails: {},
  loading: false,
  error: undefined
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined
      };
    case SET_ORDER:
      return {
        ...state,
        loading: false,
        order: action.data || [],
        error: action.error || undefined
      };
    case GET_EXISTING_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined
      };
    case SET_EXISTING_ORDERS:
      return {
        ...state,
        loading: false,
        existingOrders: action.data || [],
        error: action.error || undefined
      };
    case SET_ORDER_DELIVERY_DETAILS:
      return {
        ...state,
        loading: false,
        orderDeliveryDetails: {
          ...state.orderDeliveryDetails,
          [action.orderNumber]: action.deliveryData
        },
        error: action.error || undefined
      };
    default:
      return state;
  }
};

export default orderReducer;
